import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    source: [],
    destination: [],
    tracker: "",
    selectedSources: [],
    preSelectedSourceId: null,
    preSelectedDestinationIds: [],
};

const wizardSourceDestinationSlice = createSlice({
    name: "lastAddedSourceDestinationState",
    initialState,
    reducers: {
        selectedSources(state, action) {
            state.selectedSources = action.payload;
        },

        lastAddedSourceRedux(state, action) {
            state.source = action.payload;
        },
        lastAddedDestinationRedux(state, action) {
            state.destination = action.payload;
        },
        lastAddedTracker(state, action) {
            state.tracker = action.payload;
        },
        deleteLastAddedDest(state, action) {
            state.destination = [];
        },
        deleteLastAddedSource(state, action) {
            state.source = [];
        },
        setPreSelectedSourceId(state, action) {
            state.preSelectedSourceId = action.payload;
        },
        clearPreSelectedSourceId(state) {
            state.preSelectedSourceId = null;
        },
        setPreSelectedDestinationIds(state, action) {
            state.preSelectedDestinationIds = action.payload;
        },
        clearPreSelectedDestinationIds(state) {
            state.preSelectedDestinationIds = [];
        },
    },
});

export const {
    selectedSources,
    lastAddedSourceRedux,
    lastAddedDestinationRedux,
    lastAddedTracker,
    deleteLastAddedDest,
    deleteLastAddedSource,
    setPreSelectedSourceId,
    clearPreSelectedSourceId,
    setPreSelectedDestinationIds,
    clearPreSelectedDestinationIds,
} = wizardSourceDestinationSlice.actions;
export default wizardSourceDestinationSlice.reducer;
